import {FaPlay, FaPause, FaForward, FaBackward, FaFastForward, FaFastBackward} from "react-icons/fa";

const MapPlayerControl = ({ controller }) => {
    const buttonStyle = "w-[40px] h-[40px] hover:text-gray-900 bg-white shadow flex items-center justify-center cursor-pointer border-1 border-gray-300";

    return (
        <div className="flex justify-center text-gray-600 gap-2 mt-4 print:hidden">

            <button className={buttonStyle} onClick={controller.prevFrame} title="Retornar mês">
                <FaFastBackward/>
            </button>

            <button className={buttonStyle} onClick={() => controller.setSpeedIndex(i => Math.max(0, i - 1))} title="Diminuir velocidade">
                <FaBackward/>
            </button>

            <button className={buttonStyle} onClick={() => controller.setPlaying(p => !p)} title={controller.playing ? "Pausar" : "Iniciar"}>
                {controller.playing ? <FaPause/> : <FaPlay/>}
            </button>

            <button className={buttonStyle} onClick={() => controller.setSpeedIndex(i => Math.min(controller.speeds.length - 1, i + 1))} title="Aumentar velocidade">
                <FaForward/>
            </button>

            <button className={buttonStyle} onClick={controller.nextFrame} title="Avançar mês">
                <FaFastForward/>
            </button>

            <span className="w-[40px] h-[40px] flex items-center justify-center bg-white shadow text-sm font-bold cursor-default border-1 border-gray-300">
                {controller.speed}x
            </span>
        </div>
    );
};

export default MapPlayerControl;